export const AIRPLANES = {
    E70: {
        name: 'Embraer 170',
        seats: '78',
        speed: '830',
        direction: '3 800',
        iframeName: 'E70',
    },
    319: {
        name: 'AIRBUS A319',
        seats: '144',
        speed: '845',
        direction: '4 200',
        iframeName: '319',
    },
    320: {
        name: 'AIRBUS A320',
        seats: '8/150',
        speed: '850',
        direction: '4 300',
        iframeName: '320',
    },
    321: {
        name: 'AIRBUS A321',
        seats: '8/189 или 8/190',
        speed: '850',
        direction: '4 630',
        iframeName: '321',
    },
    738: {
        name: 'BOEING 737-800',
        seats: '8/168',
        speed: '840',
        direction: '5 765',
        iframeName: '737-800',
    },
    '76X': {
        name: 'Boeing 767-200',
    },
    AB3: {
        name: 'Airbus A300',
    },
    AB4: {
        name: 'Airbus A300B2/B4/C4',
    },
    AB6: {
        name: 'Airbus A300-600',
    },
    ABB: {
        name: 'Airbus A300-600ST Beluga',
    },
    ABF: {
        name: 'Airbus A300',
    },
    ABX: {
        name: 'Airbus A300C4/F4',
    },
    'ABY': {
        name: 'Airbus A300-600F',
    },
    310: {
        name: 'Airbus A310',
    },
    312: {
        name: 'Airbus A310-200',
    },
    313: {
        name: 'Airbus A310-300',
    },
    '31F': {
        name: 'Airbus A310C/F',
    },
    '31X': {
        name: 'Airbus A310-200C/F',
    },
    '31Y': {
        name: 'Airbus A310-300C/F',
    },
    '32S': {
        name: 'Airbus A318/319/320/321',
    },
    318: {
        name: 'Airbus A318',
    },
    330: {
        name: 'Airbus A330',
    },
    332: {
        name: 'Airbus A330-200',
    },
    333: {
        name: 'Airbus A330-300',
    },
    340: {
        name: 'Airbus A340',
    },
    342: {
        name: 'Airbus A340-200',
    },
    343: {
        name: 'Airbus A340-300',
    },
    345: {
        name: 'Airbus A340-500',
    },
    346: {
        name: 'Airbus A340-600',
    },
    380: {
        name: 'Airbus A380',
    },
    '38F': {
        name: 'Airbus A380F',
    },
    ANF: {
        name: 'Antonov AN-12',
    },
    AN4: {
        name: 'Antonov AN-24',
    },
    AN6: {
        name: 'Antonov AN-26/AN-30/AN-32',
    },
    A26: {
        name: 'Antonov AN-26',
    },
    A30: {
        name: 'Antonov AN-30',
    },
    E90: {
        name: 'Embraer 190',
    },
    A32: {
        name: 'Antonov AN-32',
    },
    AN7: {
        name: 'Antonov AN-72/AN-74',
    },
    A4F: {
        name: 'Antonov AN-124 Ruslan',
    },
    A40: {
        name: 'Antonov AN-140',
    },
    ATR: {
        name: 'Aerospatiale/Alenia ATR 42/72',
    },
    AT4: {
        name: 'Aerospatiale/Alenia ATR 42-300/320',
    },
    AT5: {
        name: 'Aerospatiale/Alenia ATR 42-500',
    },
    AT7: {
        name: 'Aerospatiale/Alenia ATR 72',
    },
    701: {
        name: 'Boeing 707-100',
    },
    703: {
        name: 'Boeing 707-300',
    },
    707: {
        name: 'Boeing 707/720',
    },
    '70F': {
        name: 'Boeing 707',
    },
    '70M': {
        name: 'Boeing 707',
    },
    717: {
        name: 'Boeing 717',
    },
    727: {
        name: 'Boeing 727',
    },
    721: {
        name: 'Boeing 727-100',
    },
    722: {
        name: 'Boeing 727-200',
    },
    '72B': {
        name: 'Boeing 727-100',
    },
    '72C': {
        name: 'Boeing 727-200',
    },
    '72M': {
        name: 'Boeing 727-200',
    },
    '72S': {
        name: 'Boeing 727-200',
    },
    '72X': {
        name: 'Boeing 727-100',
    },
    '72Y': {
        name: 'Boeing 727-200',
    },
    737: {
        name: 'Boeing 737',
    },
    731: {
        name: 'Boeing 737-100',
    },
    732: {
        name: 'Boeing 737-200',
    },
    733: {
        name: 'Boeing 737-300',
    },
    734: {
        name: 'Boeing 737-400',
    },
    735: {
        name: 'Boeing 737-500',
    },
    736: {
        name: 'Boeing 737-600',
    },
    '73G': {
        name: 'Boeing 737-700',
    },
    '73W': {
        name: 'Boeing 737-700',
    },
    '73H': {
        name: 'Boeing 737-800',
    },
    739: {
        name: 'Boeing 737-900',
    },
    '73M': {
        name: 'Boeing 737-200',
    },
    '73F': {
        name: 'Boeing 737',
    },
    '73X': {
        name: 'Boeing 737-200',
    },
    '73Y': {
        name: 'Boeing 737-300',
    },
    747: {
        name: 'Boeing 747',
    },
    741: {
        name: 'Boeing 747-100',
    },
    742: {
        name: 'Boeing 747-200',
    },
    743: {
        name: 'Boeing 747-300',
    },
    744: {
        name: 'Boeing 747-400',
    },
    '74J': {
        name: 'Boeing 747-400 Domestic',
    },
    '74L': {
        name: 'Boeing 747SP',
    },
    '74R': {
        name: 'Boeing 747SR',
    },
    '74M': {
        name: 'Boeing 747',
    },
    '74C': {
        name: 'Boeing 747-200',
    },
    '74D': {
        name: 'Boeing 747-300',
    },
    '74E': {
        name: 'Boeing 747-400',
    },
    '74F': {
        name: 'Boeing 747',
    },
    '74T': {
        name: 'Boeing 747-100',
    },
    '74X': {
        name: 'Boeing 747-200',
    },
    '74U': {
        name: 'Boeing 747-300/747-200SUD',
    },
    '74Y': {
        name: 'Boeing 747-400',
    },
    '74V': {
        name: 'Boeing 747SR',
    },
    757: {
        name: 'Boeing 757',
    },
    752: {
        name: 'Boeing 757-200',
    },
    753: {
        name: 'Boeing 757-300',
    },
    '75M': {
        name: 'Boeing 757',
    },
    '75F': {
        name: 'Boeing 757',
    },
    767: {
        name: 'Boeing 767',
    },
    762: {
        name: 'Boeing 767-200',
    },
    763: {
        name: 'Boeing 767-300',
    },
    764: {
        name: 'Boeing 767-400',
    },
    '76F': {
        name: 'Boeing 767',
    },
    '76Y': {
        name: 'Boeing 767-300',
    },
    777: {
        name: 'Boeing 777',
    },
    772: {
        name: 'Boeing 777-200',
    },
    773: {
        name: 'Boeing 777-300',
    },
    '77L': {
        name: 'Boeing 777-200LR',
    },
    '77W': {
        name: 'Boeing 777-300ER',
    },
    EMJ: {
        name: 'Embraer 170/190',
    },
    EM2: {
        name: 'Embraer EMB 120 Brasilia',
    },
    EMB: {
        name: 'Embraer EMB 110 Bandeirnate',
    },
    ERJ: {
        name: 'Embraer RJ 135/140/145',
    },
    ER3: {
        name: 'Embraer RJ 135',
    },
    ERD: {
        name: 'Embraer RJ 140',
    },
    ER4: {
        name: 'Embraer RJ 145 Amazon',
    },
    F50: {
        name: 'Fokker F50',
    },
    F70: {
        name: 'Fokker F70',
    },
    100: {
        name: 'Fokker F100',
    },
    F28: {
        name: 'Fokker F.28 Fellowship',
    },
    F21: {
        name: 'Fokker F.28 Fellowship 1000',
    },
    F22: {
        name: 'Fokker F.28 Fellowship 2000',
    },
    F23: {
        name: 'Fokker F.28 Fellowship 3000',
    },
    F24: {
        name: 'Fokker F.28 Fellowship 4000',
    },
    F27: {
        name: 'Fokker F.27 Fellowship Fairchild',
    },
    I14: {
        name: 'Ilyushin IL114',
    },
    IL8: {
        name: 'Ilyushin IL18',
    },
    IL6: {
        name: 'Ilyushin IL62',
    },
    IL7: {
        name: 'Ilyushin IL76',
    },
    ILW :{
        name: 'Ilyushin IL86',
    },
    IL9: {
        name: 'Ilyushin IL96',
    },
    I93: {
        name: 'Ilyushin IL96-300',
    },
    I9M: {
        name: 'Ilyushin IL96M',
    },
    I9F: {
        name: 'Ilyushin IL96 Cargo',
    },
    I9X: {
        name: 'Ilyushin IL96-300 Cargo',
    },
    I9Y: {
        name: 'Ilyushin IL96T',
    },
    D10: {
        name: 'McDonnell Douglas DC-10',
    },
    D11: {
        name: 'McDonnell Douglas DC-10-10/15',
    },
    D1C: {
        name: 'McDonnell Douglas DC-10-30/40',
    },
    D1F: {
        name: 'McDonnell Douglas DC-10',
    },
    D1X: {
        name: 'McDonnell Douglas DC-10-10',
    },
    D1Y: {
        name: 'McDonnell Douglas DC-10-30/40',
    },
    DC9: {
        name: 'McDonnell Douglas DC-9',
    },
    D91: {
        name: 'McDonnell Douglas DC-9-10',
    },
    D92: {
        name: 'McDonnell Douglas DC-9-20',
    },
    D93: {
        name: 'McDonnell Douglas DC-9-30',
    },
    D94: {
        name: 'McDonnell Douglas DC-9-40',
    },
    D95: {
        name: 'McDonnell Douglas DC-9-50',
    },
    M11: {
        name: 'McDonnell Douglas MD11',
    },
    M1M: {
        name: 'McDonnell Douglas MD11',
    },
    M1F: {
        name: 'McDonnell Douglas MD11',
    },
    M80: {
        name: 'McDonnell Douglas MD80',
    },
    M81: {
        name: 'McDonnell Douglas MD81',
    },
    M82: {
        name: 'McDonnell Douglas MD82',
    },
    M83: {
        name: 'McDonnell Douglas MD83',
    },
    M87: {
        name: 'McDonnell Douglas MD87',
    },
    M88: {
        name: 'McDonnell Douglas MD88',
    },
    M90: {
        name: 'McDonnell Douglas MD90',
    },
    TU3: {
        name: 'Tupolev Tu-134',
    },
    TU5: {
        name: 'Tupolev Tu-154',
    },
    T20: {
        name: 'Tupolev Tu-204/Tu-214',
    },
    'E95': {
        name: 'Embraer E-195',
    },
    '32A': {
        name: 'AIRBUS A320 NEO',
        seats: '8/156',
        speed: '845',
        direction: '6 000',
        iframeName: '320B',
    },
    '32B': {
        name: 'AIRBUS A321 NEO',
        seats: '8/195',
        speed: '845',
        direction: '6 500',
        iframeName: '320C',
    },
    '7M8': {
        name: 'Boeing 737 MAX 8',
        seats: '8/168',
        speed: '840',
        direction: '6 570',
        iframeName: '737MAX8',
    }
};